var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.792 35.833q-1.084 0-1.854-.771-.771-.77-.771-1.854V15.125q0-1.083.771-1.854.77-.771 1.854-.771h9.375V6.25q0-.833.625-1.458t1.5-.625h3.458q.875 0 1.479.625.604.625.604 1.458v6.25h9.375q1.084 0 1.854.771.771.771.771 1.854v18.083q0 1.084-.771 1.854-.77.771-1.854.771Zm0-2.083h26.416q.25 0 .396-.146.146-.146.146-.396V15.125q0-.25-.146-.396-.146-.146-.396-.146h-9.375q0 1.042-.666 1.584-.667.541-1.667.541h-3q-1 0-1.667-.541-.666-.542-.666-1.584H6.792q-.25 0-.396.146-.146.146-.146.396v18.083q0 .25.146.396.146.146.396.146Zm3.291-4.375h9.459v-.417q0-.666-.334-1.187-.333-.521-.916-.771-1.042-.417-1.834-.562-.791-.146-1.583-.146-.833 0-1.687.166-.855.167-1.813.542-.583.25-.937.771-.355.521-.355 1.187ZM23.5 26.708h6.875v-1.791H23.5Zm-8.625-1.791q.875 0 1.5-.625t.625-1.5q0-.875-.625-1.5t-1.5-.625q-.875 0-1.5.625t-.625 1.5q0 .875.625 1.5t1.5.625Zm8.625-2.542h6.875v-1.792H23.5Zm-5.208-7.792h3.458V6.25h-3.458ZM20 24.167Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBadge);
export default __webpack_public_path__ + "static/media/icon-badge.55d5a9fb20e87c2e65f43cb79cbe9b0c.svg";
export { ForwardRef as ReactComponent };